import { motion } from "framer-motion";
import { SectionHead } from "./SectionHead";
import { fadeUp, staggerWrap } from "./shared";
import { WORKS } from "../lib/site";

export default function Works() {
    return (
        <section id="lavori" className="relative py-24 md:py-32" data-testid="works-section">
            <div className="max-w-7xl mx-auto px-5 md:px-8">
                <SectionHead
                    id="lavori"
                    eyebrow="Lavori realizzati"
                    title={
                        <>
                            Cantieri che parlano <span className="text-aqua">da soli.</span>
                        </>
                    }
                />

                <motion.div
                    variants={staggerWrap}
                    initial="hidden"
                    whileInView="show"
                    viewport={{ once: true, amount: 0.1 }}
                    className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5"
                    data-testid="works-gallery"
                >
                    {WORKS.map((w, i) => (
                        <motion.figure
                            key={w.title}
                            variants={fadeUp}
                            className="group relative frame-clipped border border-white/10 overflow-hidden aspect-[4/5] cursor-pointer"
                            data-testid={`work-item-${i + 1}`}
                        >
                            <video
                                autoPlay
                                muted
                                loop
                                playsInline
                                preload="metadata"
                                className="absolute inset-0 w-full h-full object-cover img-treated"
                            >
                                <source src={w.video} type="video/mp4" />
                                <source src={w.web} type="video/webm" />
                            </video>
                            <div className="absolute inset-0 bg-gradient-to-t from-bitume/95 via-bitume/20 to-transparent opacity-90 transition-opacity duration-500 group-hover:opacity-100" />
                            <figcaption className="absolute inset-x-0 bottom-0 p-6 flex items-end justify-between gap-4">
                                <div>
                                    <span className="font-mono2 text-[10px] uppercase tracking-[0.22em] text-aqua block mb-1.5">
                                        {w.tag}
                                    </span>
                                    <span className="font-display font-semibold tracking-tight text-lg text-cloud leading-snug block">
                                        {w.title}
                                    </span>
                                </div>
                                <span className="font-mono2 text-xs text-ash/70">
                                    {String(i + 1).padStart(2, "0")}
                                </span>
                            </figcaption>
                            <span className="absolute top-0 left-0 h-[3px] w-0 bg-ambra transition-all duration-500 group-hover:w-full" />
                        </motion.figure>
                    ))}
                </motion.div>
            </div>
        </section>
    );
}
